module.exports = __webpack_public_path__ + "img/radio-checked.f565c1b3.svg";